// import React, { useContext, useState } from "react";
// import Background from "../../assets/profile/back1.jpeg";
// import { useAppSelector } from "../../redux/ReduxType";
// import AuthContext from "../../context/AuthProvider";
// import { CgProfile } from "react-icons/cg";
// import { POST_URL, USER_URL } from "../../constant/resource";
// import { toast } from "sonner";
// import { fetchData } from "../../utils/axisoCall";
// import LoaderSpinner from "../molecules/Loader/Loader.spinner";
// import { useNavigate } from "react-router-dom";
// import { IUser } from "../../type/user.type";
// import { useFetchData } from "../../hooks/useFetchData";
// import { checkFriend, hasSendRequest } from "./data";

// interface IProfileData {
//   data: IUser | undefined;
//   refetch?: () => void;
// }

// const ProfileData: React.FC<IProfileData> = (data, refetch) => {
//   const isDark = useAppSelector((state) => state.theme.isDark);
//   const { auth } = useContext(AuthContext);
//   const user = useAppSelector((state) => state.user);
//   const [loadingFriend, setLoadingFriend] = useState<boolean>(false);
//   const navigate = useNavigate();
//   // ----- fetch user details and fill the page ----------

//   const isFollower = data.data?.followers?.includes(user?._id);
//   const isFreind = checkFriend(user?._id, data?.data?.friends);

//   const sentRequest = hasSendRequest(user?._id, data?.data?.friendRequest);

//   const handleFollowRequest = () => {
//     if (!user?._id) {
//       toast.error("signin to continue");
//       navigate("/register");
//       return;
//     }
//     // (user._id, data?.data?._id)
//     // if (isFollower) return toast.info("You already follow this person");
//     const payload = {
//       follower: user._id,
//       following: data?.data?._id,
//     };

//     const onSuccess = (data: any) => {
//       toast.success("success");
//       refetch();
//     };

//     const onFailure = (error: any) => {
//       toast.error("error");
//       console.log(error);
//     };

//     fetchData({
//       url: `${USER_URL}/follow`,
//       method: "PUT",
//       payload,
//       onSuccess,
//       onFailure,
//     });
//   };

//   const handleUnfollowRequest = () => {
//     // (user._id, data?.data?._id)
//     const payload = {
//       follower: user._id,
//       floowing: data?.data?._id,
//     };

//     const onSuccess = (data: any) => {
//       toast.success("success");
//       // console.log("follow response ---->", data);
//     };

//     const onFailure = (error: any) => {
//       toast.error("error");
//       console.log(error);
//     };

//     fetchData({
//       url: `${POST_URL}/follow`,
//       method: "PUT",
//       payload,
//       onSuccess,
//       onFailure,
//     });
//   };

//   const handleFriendRequest = () => {
//     if (!user?._id) {
//       toast.error("signin to continue");
//       navigate("/register");
//       return;
//     }
//     if (isFreind) return toast.info("You are already friend with this person");
//     try {
//       setLoadingFriend(true);
//       const payload = {
//         from: user._id,
//         to: data?.data?._id,
//       };

//       // console.log("data --->", payload);

//       const onSuccess = (data: any) => {
//         toast.success("success");
//         console.log("follow response ---->", data);
//       };

//       const onFailure = (error: any) => {
//         toast.error(error?.response?.data?.Message);
//         console.log(error);
//       };

//       const final = () => {
//         setLoadingFriend(false);
//       };

//       fetchData({
//         url: `${USER_URL}/friend`,
//         method: "POST",
//         payload,
//         onSuccess,
//         onFailure,
//         final,
//       });
//     } catch (error: any) {
//       console.log(error);
//     }
//   };

//   return (
//     <div>
//       <section className="w-full h-[350px] relative text-sm">
//         {data?.data?.profile ? (
//           <img
//             className="object-cover h-full w-full"
//             src={data?.data?.profile}
//             alt="background"
//           />
//         ) : (
//           <img
//             className="object-cover h-full w-full"
//             src={Background}
//             alt="background"
//           />
//         )}
//         <div className="absolute -bottom-8 left-0 flex items-start justify-start gap-5">
//           {data?.data?.avatar ? (
//             <img
//               className="w-10 h-10 rounded-full object-cover shadow-md"
//               src={data?.data?.avatar}
//               alt="profile"
//             />
//           ) : (
//             <CgProfile className="w-10 h-10 text-white" />
//           )}
//           <div>
//             <h2
//               className={`text-2xl font-bold ${
//                 !isDark && "text-lightText"
//               } mb-2`}
//             >
//               {auth?.fullname}
//             </h2>
//             <div
//               className={`flex items-start flex-col shadow-md p-5 justify-start gap-2 font-semibold rounded-md ${
//                 isDark ? "bg-deepBg text-lightText" : "bg-deepLight text-deepBg"
//               }`}
//             >
//               <p className="text-balance">{data?.data?.fullname || "N/A"}</p>
//               <p className="text-balance">{data?.data?.username || "N/A"}</p>
//               <p className="text-balance">{data?.data?.state || "N/A"}</p>
//               {/* <p className='text-balance'>New York, NY</p> */}
//               <p className="text-balance">
//                 {data?.data?.followers?.length}{" "}
//                 <span className="text-blue-400">followers</span>
//               </p>
//               <div className="flex items-center justify-center gap-3">
//                 {isFollower ? (
//                   <button
//                     onClick={() => {
//                       handleUnfollowRequest();
//                     }}
//                     className={`text-sm px-5 py-2 rounded-full ${
//                       isDark
//                         ? "bg-lightBg text-deepBg"
//                         : "bg-deepBg text-lightText"
//                     }`}
//                   >
//                     UnFollow
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => {
//                       handleFollowRequest();
//                     }}
//                     className={`text-sm px-5 py-2 rounded-full ${
//                       isDark
//                         ? "bg-lightBg text-deepBg"
//                         : "bg-deepBg text-lightText"
//                     }`}
//                   >
//                     Follow
//                   </button>
//                 )}
//                 {!isFreind && !sentRequest ? (
//                   <button
//                     onClick={handleFriendRequest}
//                     className={`text-sm px-5 py-2 rounded-full ${
//                       isDark
//                         ? "bg-lightBg text-deepBg"
//                         : "bg-deepBg text-lightText"
//                     }`}
//                   >{`${
//                     loadingFriend ? (
//                       <LoaderSpinner color="blue" />
//                     ) : (
//                       "Send Request"
//                     )
//                   }`}</button>
//                 ) : null}

//                 <button
//                   onClick={handleFollowRequest}
//                   className={`text-sm px-5 py-2 rounded-full ${
//                     isDark
//                       ? "bg-lightBg text-deepBg"
//                       : "bg-deepBg text-lightText"
//                   }`}
//                 >
//                   {sentRequest ? "Withdraw Request" : "Unfriend User"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };
// export default ProfileData;

// -- version 2 ---
import React, { useState } from "react";
import Background from "../../assets/profile/back1.jpeg";
import { useAppSelector } from "../../redux/ReduxType";
// import AuthContext from "../../context/AuthProvider";
import { CgProfile } from "react-icons/cg";
import { USER_URL } from "../../constant/resource";
import { toast } from "sonner";
// import { fetchData } from "../../utils/axisoCall";
import LoaderSpinner from "../molecules/Loader/Loader.spinner";
import { useNavigate } from "react-router-dom";
import { IUser } from "../../type/user.type";
import { checkFriend, hasSendRequest } from "./data";
import { useMakeRequest } from "../../hooks/useMakeRequest";

interface IProfileData {
  data: IUser | undefined;
  refetch?: () => void;
}

const ProfileData: React.FC<IProfileData> = ({ data, refetch }) => {
  const isDark = useAppSelector((state) => state.theme.isDark);
  // const { auth } = useContext(AuthContext);
  const makeRequest = useMakeRequest();
  const user = useAppSelector((state) => state.user);
  const [loadingFriend, setLoadingFriend] = useState<boolean>(false);
  const navigate = useNavigate();

  const isFollower = data?.followers?.includes(user?._id);
  const isFriend = checkFriend(user?._id, data?.friends);
  const sentRequest = hasSendRequest(user?._id, data?.friendRequest);

  const handleFollowRequest = () => {
    if (!user?._id) {
      toast.error("Sign in to continue");
      navigate("/register");
      return;
    }
    const payload = {
      follower: user._id,
      following: data?._id,
    };

    const onSuccess = () => {
      toast.success("Follow action successful");
      refetch?.();
    };

    const onFailure = (error: any) => {
      toast.error("Error following user");
      console.log(error);
    };

    makeRequest(
      `${USER_URL}/follow`,
      "PUT",
      payload,
      onSuccess,
      onFailure,
      () => {}
    );
  };

  const handleUnfollowRequest = () => {
    const payload = {
      follower: user._id,
      following: data?._id,
    };

    const onSuccess = () => {
      toast.success("Unfollowed successfully");
      refetch?.();
    };

    const onFailure = (error: any) => {
      toast.error("Error unfollowing user");
      console.log(error);
    };

    makeRequest(
      USER_URL + `/follow`,
      "PUT",
      payload,
      onSuccess,
      onFailure,
      () => {}
    );
  };

  const handleFriendRequest = () => {
    if (!user?._id) {
      toast.error("Sign in to continue");
      navigate("/register");
      return;
    }
    if (isFriend) {
      toast.info("You are already friends with this person");
      return;
    }
    try {
      setLoadingFriend(true);
      const payload = {
        from: user._id,
        to: data?._id,
      };

      const onSuccess = () => {
        toast.success(
          sentRequest ? "Request withdrawn" : "Friend request sent"
        );
        refetch?.();
      };

      const onFailure = (error: any) => {
        toast.error(error?.response?.data?.Message || "Error sending request");
        console.log(error);
      };

      const final = () => {
        setLoadingFriend(false);
      };

      makeRequest(
        USER_URL + "/friend",
        sentRequest ? "DELETE" : "POST",
        payload,
        onSuccess,
        onFailure,
        final
      );
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleUnfriend = () => {
    try {
      setLoadingFriend(true);
      const payload = {
        from: user._id,
        to: data?._id,
      };

      const onSuccess = () => {
        toast.success("Unfriended successfully");
        refetch?.();
      };

      const onFailure = (error: any) => {
        toast.error("Error unfriending user");
        console.log(error);
      };

      const final = () => {
        setLoadingFriend(false);
      };

      makeRequest(
        USER_URL + "/friend",
        "DELETE",
        payload,
        onSuccess,
        onFailure,
        final
      );
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <section className="relative w-full h-[300px] rounded-lg overflow-hidden shadow-lg">
        <img
          className="object-cover h-full w-full transition-transform duration-300 hover:scale-105"
          src={data?.profile || Background}
          alt="Background"
        />
        <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/60 to-transparent p-6">
          <div className="flex items-end gap-4">
            {data?.avatar ? (
              <img
                className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-md"
                src={data.avatar}
                alt="Profile"
              />
            ) : (
              <CgProfile className="w-16 h-16 text-white" />
            )}
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-white mb-1">
                {data?.fullname || "N/A"}
              </h2>
              <p className="text-gray-200">@{data?.username || "N/A"}</p>
            </div>
          </div>
        </div>
      </section>
      <section
        className={`mt-4 p-6 rounded-lg shadow-md ${
          isDark ? "bg-gray-800 text-white" : "bg-white text-gray-800"
        }`}
      >
        <div className="space-y-2">
          <p className="text-sm">Location: {data?.state || "N/A"}</p>
          <p className="text-sm">
            <span className="font-semibold">
              {data?.followers?.length || 0}
            </span>{" "}
            <span className="text-blue-400">followers</span>
          </p>
        </div>
        <div className="mt-4 flex flex-wrap gap-3">
          {isFollower ? (
            <button
              onClick={handleUnfollowRequest}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
                isDark
                  ? "bg-gray-600 text-white hover:bg-gray-700"
                  : "bg-gray-200 text-gray-800 hover:bg-gray-300"
              }`}
            >
              Unfollow
            </button>
          ) : (
            <button
              onClick={handleFollowRequest}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
                isDark
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Follow
            </button>
          )}
          {isFriend ? (
            <button
              onClick={handleUnfriend}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
                isDark
                  ? "bg-red-600 text-white hover:bg-red-700"
                  : "bg-red-500 text-white hover:bg-red-600"
              }`}
            >
              {loadingFriend ? <LoaderSpinner color="white" /> : "Unfriend"}
            </button>
          ) : (
            <button
              onClick={handleFriendRequest}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
                isDark
                  ? "bg-green-600 text-white hover:bg-green-700"
                  : "bg-green-500 text-white hover:bg-green-600"
              }`}
            >
              {loadingFriend ? (
                <LoaderSpinner color="white" />
              ) : sentRequest ? (
                "Withdraw Request"
              ) : (
                "Send Request"
              )}
            </button>
          )}
        </div>
      </section>
    </div>
  );
};

export default ProfileData;
